import React from 'react';
import Layout from '../src/Pages/Main/Layout'
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import About from './Pages/About/About';
import { HashLink as Link } from 'react-router-hash-link';
import Contact from './Pages/Contact/Contact';
import Hero from './Pages/Hero/Hero';
import Skill from './Pages/Skill/Skill';
import Work from './Pages/Work/Work';


function App() {

  const router = createBrowserRouter([
    {
      path: '/',
      element: <Layout></Layout>,
      children : [
        {
          path: '/about',
          element: <About></About>
        },
        {
          path: '/contact',
          element: <Contact></Contact>
        },
        {
          path: '/home',
          element: <Hero></Hero>
        },
        {
          path: '/skill',
          element: <Skill></Skill>
        },
        {
          path: '/blog',
          element: <Work></Work>
        }
      ]
    }
  ])
  return (
    <div>
     <RouterProvider router={router}> <Layout></Layout></RouterProvider>
    </div>
  );
}

export default App;
